export default __webpack_public_path__ + "static/media/contactBackground.613d9f50.png";